var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{staticClass:"elevation-0",attrs:{"height":"45","color":"gray"}},[_c('v-toolbar-title',[_c('h1',{staticClass:"subheading"},[_vm._v("Ticket By User")])])],1),_c('div',{attrs:{"id":"ticket-line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }